// [documentation] - docs/Modal.md

import mixpanel from "mixpanel-browser";
import React, { useState } from "react";
import ReactGA from "react-ga";
import { Urls } from "../../Urls";
import { Activity, currentRequestTimeStamp, encryptor } from "./../Constants";
import styles from "./modal.module.css";
import Rating from "react-rating";

const Modal = ({ show, onClose, children, isClosable }) => {
  if (!show) return null;

  return (
    <div
      className={styles["modal-overlay"]}
      onClick={isClosable ? onClose : null}
    >
      <div
        className={styles["modal-content"]}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};

export const NoAccessModal = ({ show, handleClose, isClosable }) => {
  return (
    <Modal show={show} onClose={handleClose}>
      <div style={{ padding: "10px" }}>
        <div className={`${styles["modal-header"]}`}>
          <h4 className={`${styles["modal-title"]}`}>
            You have reached the maximum search limit!
          </h4>
          {isClosable && (
            <button
              type="button"
              className={styles["modal-close"]}
              onClick={handleClose}
            >
              <span>&times;</span>
            </button>
          )}
        </div>
        <div className={`${styles["modal-body"]}`}>
          <p>
            Please Signup/Login on LoRRI to continue or{" "}
            <a
              href={Urls.ClientBaseUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              click here
            </a>
          </p>
        </div>
        <div className={`${styles["modal-footer"]}`}>
          <button
            className="btn btn-primary"
            onClick={() => {
              Activity([
                {
                  screen: "Signup Popup",
                  module: "Schedule Demo Button",
                  user_activity: "Schedule Demo Button Clicked",
                  timestamp: currentRequestTimeStamp(),
                },
              ]);
              ReactGA.event({
                category: "Signup Popup",
                action: `Schedule Demo Button Clicked`,
              });
              mixpanel.track(`User has clicked on Schedule Demo button`, {
                ApplicationName: `${Urls.mixpanelappname}`,
                ScreenName: "Signup Popup",
                ModuleName: "signup_popup",
                ActivityLog: `userClickedScheduleDemoButton`,
                Data: `None`,
                Definition: `User has clicked on Schedule Demo button`,
                ActivityType: "event_view",
              });

              handleClose();

              window.location.href =
                window.location.pathname === "/"
                  ? "#schedule-form"
                  : "/#schedule-form";
            }}
          >
            <b>SCHEDULE MEETING/ DEMO NOW</b>
          </button>
        </div>
      </div>
    </Modal>
  );
};

export const TransporterLists = ({
  show,
  handleClose,
  isClosable,
  transporterList,
  heading,
}) => {
  return (
    <Modal show={show} onClose={handleClose}>
      <div>
        <div className={`${styles["modal-header"]}`}>
          <h6 className={`${styles["modal-title"]}`}>{heading}</h6>
          {isClosable && (
            <button
              type="button"
              className={styles["modal-close"]}
              onClick={handleClose}
            >
              <span>&times;</span>
            </button>
          )}
        </div>
        <div className={`${styles["modal-body"]}`}>
          <div
            style={{
              maxHeight: "350px",
              overflow: "scroll",
              marginTop: "4px",
              scrollbarWidth: "thin",
            }}
          >
            {transporterList &&
              transporterList.map((item) => (
                <ul key={item.transporter_id} style={{ marginRight: "10px" }}>
                  <li style={{ textAlign: "center" }}>
                    <a
                      href={`${Urls.ClientBaseUrl}tpmp/${encryptor(
                        item.transporter_id,
                        true
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#393185" }}
                      onClick={() => {
                        mixpanel.track(
                          `User has clicked on transporter profile`,
                          {
                            ApplicationName: `${Urls.mixpanelappname}`,
                            ScreenName: "search_transporter_page",
                            ModuleName: "search_transporter_page",
                            ActivityLog: `userClickedTransporterProfile`,
                            Data: `${item.transporter_name}`,
                            Definition: `User has clicked on transporter profile`,
                            ActivityType: "event_view",
                          }
                        );
                      }}
                    >
                      {item.transporter_name.toUpperCase()}
                    </a>
                  </li>
                  <li style={{ textAlign: "center" }}>
                    <Rating
                      initialRating={item.overall_rating}
                      fullSymbol={
                        <i
                          className="material-icons"
                          style={{ color: "orange" }}
                        >
                          star
                        </i>
                      }
                      emptySymbol={
                        <i
                          className="material-icons"
                          style={{ color: "orange" }}
                        >
                          star_border
                        </i>
                      }
                      readonly="true"
                    />
                  </li>
                  <hr />
                </ul>
              ))}
          </div>
        </div>
        <div className={`${styles["modal-footer"]}`}>
          <button
            className="btn btn-primary"
            onClick={() => {
              ReactGA.event({
                category: "SearchTransporter",
                action: `Signup Clicked`,
              });
              mixpanel.track(`User has clicked on signup button`, {
                ApplicationName: `${Urls.mixpanelappname}`,
                ScreenName: "search_transporter_page",
                ModuleName: "search_transporter_page",
                ActivityLog: `userClickedSignupButton`,
                Data: `None`,
                Definition: `User has clicked on signup button`,
                ActivityType: "event_view",
              });

              window.open(Urls.ClientBaseUrl, "_blank", "noopener,noreferrer");
            }}
          >
            <b>Sign Up</b>
          </button>
        </div>
      </div>
    </Modal>
  );
};

export const CollectEmailModal = ({
  show,
  handleClose,
  emailInputHandler,
  numberInputHandler,
  submitHandler,
  isClosable,
}) => {
  const [error, setError] = useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
    const success = submitHandler(e);
    if (!success) {
      setError("Please enter a valid email address");
    } else {
      setError("");
    }
  };

  return (
    <Modal show={show} onClose={handleClose}>
      <div className={styles["modal-header"]}>
        <h4 className={styles["modal-title"]}>
          Please provide your email id and phone number to proceed!
        </h4>
        {isClosable && (
          <button className={styles["modal-close"]} onClick={handleClose}>
            &times;
          </button>
        )}
      </div>
      {error && <div className={styles["error-message"]}>{error}</div>}
      <div className={styles["modal-body"]}>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            className={styles["modal-input"]}
            onChange={(e) => {
              emailInputHandler(e);
              setError("");
            }}
            placeholder="Enter your email address"
            required
            autoFocus
          />
          <input
            type="number"
            className={styles["modal-input"]}
            onChange={numberInputHandler}
            placeholder="Enter your phone number"
          />
        </form>
      </div>
      <div className={styles["modal-footer"]}>
        <button className="btn btn-primary" onClick={handleSubmit}>
          Submit
        </button>
      </div>
    </Modal>
  );
};
